module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/1-c3b0afce9a3f0a70fc8c9a9da461b45a.webp";